import { HttpHeaders } from '@angular/common/http';

export class APISettings { 
  public static apiBaseAddress = 'https://ipp.doh.gov.ae/ProviderAPI';
  //public static apiBaseAddress = 'http://localhost:58828';
  //public static apiBaseAddress = 'https://ipptest.doh.gov.ae/ProviderAPI';
  //public static apiBaseAddress = 'https://aeadvsa421-doh/ProviderAPI';  
  //public static apiBaseAddress = 'https://qa.manteq-me.com:44333/Provider.API';  
  //public static apiBaseAddress = 'https://qa.manteq-me.com:44333/Provider.API';  
  //public static apiBaseAddress = 'http://localhost:58828';

  public static clemittanceBaseAddress = 'https://ipp.doh.gov.ae/ClemittanceAPI';
  // public static clemittanceBaseAddress = 'https://ipptest.doh.gov.ae/ClemittanceAPI';
  //public static clemittanceBaseAddress = 'https://qa.manteq-me.com:44333/ClemittanceIPC.API';

  public static portalDownload = 'https://ipp.doh.gov.ae/how-to/';
  // public static portalDownload = 'https://ipptest.doh.gov.ae/how-to/';

  public static clemittanceLink = 'https://ipp.doh.gov.ae/Clemittance/';
  // public static clemittanceLink = 'https://ipptest.doh.gov.ae/Clemittance/';
  // public static clemittanceLink = 'https://aeadvsa421-doh/Clemittance';
  // public static clemittanceLink = 'https://qa.manteq-me.com:44333/clemittance#';
  // public static clemittanceLink = 'https://localhost:44354/';

  public static httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
}